// extracted by mini-css-extract-plugin
export var answer = "n_br";
export var item = "n_bp";
export var question = "n_bq";